import { createSlice } from "@reduxjs/toolkit";

export interface ToolbarState {
    show3d: boolean;
    showPano: boolean;
    showImport: boolean;
    showTKGM: boolean;
    showRapor: boolean;
    showEtahsis: boolean;
    showHelp: boolean;
    showInfo: boolean;
}

const initialState: ToolbarState = {
    show3d: false,
    showPano: false,
    showImport: false,
    showTKGM: false,
    showRapor: false,
    showEtahsis: false,
    showHelp: false,
    showInfo: false,
};

export const toolbarSlice = createSlice({
    name: 'sharedState',
    initialState,
    reducers: {
        setShow3d: (state: ToolbarState, action) => {
            state.show3d = action.payload;
        },
        setShowPano: (state: ToolbarState, action) => {
            state.showPano = action.payload;
        },
        setShowImport: (state: ToolbarState, action) => {
            state.showImport = action.payload;
        },
        setShowRapor: (state: ToolbarState, action) => {
            state.showRapor = action.payload;
        },
        setShowEtahsis: (state: ToolbarState, action) => {
            state.showEtahsis = action.payload;
        },
        setShowTKGM: (state: ToolbarState, action) => {
            state.showTKGM = action.payload;
        },
        setShowHelp: (state: ToolbarState, action) => {
            state.showHelp = action.payload;
        },
        setShowInfo: (state: ToolbarState, action) => {
            state.showInfo = action.payload;
        },
    }
})

export const { setShow3d, setShowPano, setShowImport, setShowRapor, setShowEtahsis, setShowTKGM, setShowHelp,setShowInfo } = toolbarSlice.actions;
export default toolbarSlice.reducer;